const breadCrumb = "Diário Digital";

const routes = [
  {
    path: "/acesso-servidor",
    name: "acesso-servidor",
    meta: {
      allowedPermissions: ["acesso_servidor_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ParametrosDiario/AcessoServidor/AcessoServidorHome.vue"),
  },
];

export default routes;
